export default __webpack_public_path__ + "static/media/ANGELA.4ee27577.jpg";